module.exports = __webpack_public_path__ + "img/ganguo.3fecc40b.png";